import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-answer-modal',
  standalone: true,
  imports: [MarkdownModule],
  templateUrl: './answer-modal.component.html',
  styleUrls: ['./answer-modal.component.scss']
})
export class AnswerModalComponent {
  @ViewChild('answerMarkdown', { static: false, read: ElementRef }) answerMarkdownRef?: ElementRef;
  constructor(
    public dialogRef: MatDialogRef<AnswerModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { answer: string },
    private snackBar: MatSnackBar
  ) {}

  close() { this.dialogRef.close(); }

  copyAnswer() {
    let textToCopy = '';
    if (this.answerMarkdownRef && this.answerMarkdownRef.nativeElement) {
      textToCopy = this.answerMarkdownRef.nativeElement.innerText || this.data.answer;
    } else {
      textToCopy = this.data.answer;
    }
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.snackBar.open('Copied to clipboard!', '', { duration: 2000 });
    }, () => {
      this.snackBar.open('Failed to copy.', '', { duration: 2000 });
    });
  }

  htmlEscape(input?: string | null): string {
    if (input === undefined || input === null) return '';
    return input
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/\//g, '&#x2F;')
      .replace(/\r\n/g, '\n')
      .replace(/`/g, '&#96;');
  }
  toMarkdownString(val: any): string {
    if (typeof val === 'string') {
      const withLineBreaks = val.replace(/\r\n|\r|\n/g, '  \n');
      return this.htmlEscape(withLineBreaks);
    }
    if (val === undefined || val === null) return '';
    try {
      return this.htmlEscape(String(val));
    } catch {
      return '';
    }
  }
}

